import { Button } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';

import { resolvePathFromSearch } from '../utils/routeParams';

interface ResolveNowLinkProps {
  submissionId: number;
  label?: string;
}

const ResolveNowLink = ({
  submissionId,
  label = 'Resolve now',
}: ResolveNowLinkProps) => {
  const { search } = useLocation();

  return (
    <Button
      component={Link}
      variant="contained"
      size="small"
      color="warning"
      to={resolvePathFromSearch(search, submissionId)}
    >
      {label}
    </Button>
  );
};

export default ResolveNowLink;
